<template lang="html">
  <v-dialog v-model="consentOnechatDialog" width="600px" persistent>
    <v-card calss="pa-0">
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;{{$t('RightSide.header.privatepolicy')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn dark icon flat @click.native="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn> -->
      </v-toolbar>
      <!-- <v-divider></v-divider> -->
      <v-card-text style="height: 550px; background-color: #2463af;" class="scrolling-wrapper-y">
        <iframe width="500" height="550" style="visibility: visible; justify-content: center; align-items: center; width: 100%;" frameborder='0' :src="url_consent" allow="geolocation"></iframe>
      </v-card-text>
      <!-- <v-divider></v-divider> -->
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    consentOnechatDialog: Boolean,
    url_consent: String
  },
  data () {
    return {
    }
  },
  watch: {
    consentOnechatDialog () {
      if (this.consentOnechatDialog) {
        // console.log(this.url_consent)
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialogConsentOnechat', false)
    }
  }
}
</script>

<style lang="css" scoped>
.scrolling-wrapper-y {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper-y::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper-y::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/consent/consent_onechat_dialog.vue